import RenderQ from "./RenderQ";

const UnAnsweredQuestions = ({ questArray }) => {
  return <RenderQ questArray={questArray} />;
};

export default UnAnsweredQuestions;
